import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const mapTimePanelVisibleState = atom({
  key: 'mapTimePanelVisibleState',
  default: selector({
    key: 'mapTimePanelVisibleStateSelector',
    get: () => {
      return getCustomerSettings('mapConfig.TIME_PANEL');
    }
  })
});